import React from 'react';
import './Home.css';
import { GuideLink } from '../common';
import { ROLE_GUIDES } from '../../utils';

interface Props {
  userName: string;
  onNavigate: (tab: 'home' | 'team-settings' | 'content-review' | 'spec-writer' | 'strategy' | 'video-editor') => void;
}

const Home: React.FC<Props> = ({ userName, onNavigate }) => {
  const firstName = userName.split(' ')[0];

  return (
    <div className="home-container">
      <div className="home-hero">
        <h1>Welcome to CellcoHub, {firstName}</h1>
        <p className="home-subtitle">
          Your central productivity platform for content review, team management, and AI-assisted production
        </p>
      </div>

      <div style={{ margin: '0 0 18px', fontSize: 14 }}>
        <strong style={{ marginRight: 10 }}>Role guides:</strong>
        <span style={{ display: 'inline-flex', gap: 14, flexWrap: 'wrap' }}>
          <GuideLink href={ROLE_GUIDES.producer} label="Producer" />
          <GuideLink href={ROLE_GUIDES.reviewer} label="Reviewer" />
          <GuideLink href={ROLE_GUIDES.decisionMaker} label="Decision maker" />
        </span>
      </div>

      <div className="home-modules">
        <h2>Available Modules</h2>
        {/* Flow order (walk station 1): spec -> produce -> review, then
            reference + admin. Mirrors the nav. */}
        <div className="modules-grid">
          <div className="module-card" onClick={() => onNavigate('spec-writer')}>
            <div className="module-icon">📝</div>
            <h3>Spec Writer</h3>
            <p>Draft product and campaign specifications with structured assistance</p>
            <button className="module-button">Open Module →</button>
          </div>

          <div className="module-card" onClick={() => onNavigate('video-editor')}>
            <div className="module-icon">🎬</div>
            <h3>Video Editor</h3>
            <p>Assemble Remotion compositions, testimonials, and captioned segments with the AI co-pilot</p>
            <button className="module-button">Open Module →</button>
          </div>

          <div className="module-card" onClick={() => onNavigate('content-review')}>
            <div className="module-icon">✅</div>
            <h3>Content Review</h3>
            <p>Route reviewer, MRL, and DM assessments for content submitted from SharePoint</p>
            <button className="module-button">Open Module →</button>
          </div>

          <div className="module-card" onClick={() => onNavigate('strategy')}>
            <div className="module-icon">📋</div>
            <h3>Strategy</h3>
            <p>Marketing strategy documentation and planning reference</p>
            <button className="module-button">Open Module →</button>
          </div>

          <div className="module-card" onClick={() => onNavigate('team-settings')}>
            <div className="module-icon">⚙️</div>
            <h3>Team Settings</h3>
            <p>Manage team members, set capacity, and configure module permissions</p>
            <button className="module-button">Open Module →</button>
          </div>
        </div>
      </div>

      <div className="home-footer">
        <p className="footer-text">
          CellcoHub integrates your productivity tools into one unified platform
        </p>
      </div>
    </div>
  );
};

export default Home;
